import _ from "@lodash";
import { InputAdornment, Paper, TextField, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import EmpresaFormaPagamentoApp from "app/ERP/EmpresaFormaPagamento/EmpresaFormaPagamentoApp";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    paper: {
        border: "1px solid " + theme.palette.divider,
        padding: "4px",
        minHeight: 58
    },
    cor: {
        color: theme.palette.text.primary,
    }
});

const newTarefaApontamentoState = {
    primeirovencimento: Helpers.GetDataAtual(null, "usa"),
    parcela: 1,
    idpessoaformularioformapagamento: null,
    idpessoaformularioformapagamentodescricao: null,
    entrada: 0,
};

const ModeloParcela = {
    idtarefaprocessoapontamentoitem: null,
    idtemporario: new Date().getTime(),
    quantidade: 1,
    desconto: 0,
    acrescimo: 0,
    vencimento: Helpers.GetDataAtual(null, "usa"),
    vencimentodescricao: Helpers.GetDataAtual(null, "br"),
    idpessoaformularioformapagamento: null,
    idpessoaformularioformapagamentodescricao: null
};

class TarefaApontamentoGeradorParcela extends XAPPComponent {

    state = { ...newTarefaApontamentoState };

    componentDidMount() {
        const form = this.state;
        const { setItens, Apontamento, FormasPagamento = null } = this.props;
        let AObj = Object.assign({}, ModeloParcela);
        AObj.valor = Apontamento.valortotal;
        AObj.valordescricao = "R$ " + Apontamento.valortotal;
        AObj.vencimento = form.primeirovencimento;
        AObj.vencimentodescricao = Helpers.StringDateUSToBR(form.primeirovencimento);
        if (!_.isNull(FormasPagamento)) {
            const AFormaPagamento = _.find(FormasPagamento, x => x.formulario.default === 1);
            if (!_.isUndefined(AFormaPagamento)) {
                AObj.idpessoaformularioformapagamento = AFormaPagamento.idpessoaformulario;
                AObj.idpessoaformularioformapagamentodescricao = AFormaPagamento.nome;

                let AForm = Object.assign({}, this.state);
                AForm.idpessoaformularioformapagamento = AFormaPagamento.idpessoaformulario;
                AForm.idpessoaformularioformapagamentodescricao = AFormaPagamento.nome;
                this.setState(_.set({ ...AForm }));
            }
        }
        setItens([AObj]);
    }

    componentDidUpdate(prevProps) {
        const form = this.state;
        const { setItens, Apontamento, aprazo = false, FormasPagamento = null } = this.props;
        if ((prevProps.aprazo && !aprazo) || (prevProps.Apontamento.valortotal !== Apontamento.valortotal)) {
            let AObj = Object.assign({}, ModeloParcela);
            AObj.valor = Apontamento.valortotal;
            AObj.valordescricao = "R$ " + Apontamento.valortotal;
            AObj.vencimento = form.primeirovencimento;
            AObj.vencimentodescricao = Helpers.StringDateUSToBR(form.primeirovencimento);
            if (!_.isNull(FormasPagamento)) {
                const AFormaPagamento = _.find(FormasPagamento, x => x.formulario.default === 1);
                if (!_.isUndefined(AFormaPagamento)) {
                    AObj.idpessoaformularioformapagamento = AFormaPagamento.idpessoaformulario;
                    AObj.idpessoaformularioformapagamentodescricao = AFormaPagamento.nome;

                    let AForm = Object.assign({}, this.state);
                    AForm.idpessoaformularioformapagamento = AFormaPagamento.idpessoaformulario;
                    AForm.idpessoaformularioformapagamentodescricao = AFormaPagamento.nome;
                    this.setState(_.set({ ...AForm }));
                }
            }
            setItens([AObj]);
        }
    }

    handleChange = (ev) => {
        this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
    };

    handleChangeFormaPagamento = (_AValue = null) => {
        var obj = Object.assign({}, this.state);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj["idpessoaformularioformapagamento"] = _AValue[0].idpessoaformulario;
            obj["idpessoaformularioformapagamentodescricao"] = _AValue[0].nome;
            this.setState(obj);
        }
        else {
            obj["idpessoaformularioformapagamento"] = null;
            obj["idpessoaformularioformapagamentodescricao"] = null;
            this.setState(obj);
        }
    };

    canBeSubmitted() {
        const { Apontamento } = this.props;
        const { primeirovencimento, parcela, idpessoaformularioformapagamento, entrada } = this.state;
        return (
            parcela !== null && parcela !== "" &&
            primeirovencimento !== null && primeirovencimento !== "" &&
            idpessoaformularioformapagamento !== null && idpessoaformularioformapagamento !== "" &&
            Number(entrada) < Number(Apontamento.valortotal)
        );
    }

    gerarParcelas = () => {
        const form = this.state;
        const { Apontamento, setItens } = this.props;
        let AValorParcelar = Number(form.entrada) > 0 ? Number(Apontamento.valortotal) - Number(form.entrada) : Number(Apontamento.valortotal);
        let AValorParcela = Number((AValorParcelar / Number(form.parcela)).toFixed(2));
        let AValorPrimeiraParcela = Number((AValorParcelar - Number(AValorParcela * (Number(form.parcela) - 1))).toFixed(2));
        let AArray = [];
        let AVencimento = form.primeirovencimento;

        if (Number(form.entrada) > 0) {
            let AObj = Object.assign({}, ModeloParcela);
            AObj.valor = Number(Number(form.entrada).toFixed(2));
            AObj.valordescricao = "R$ " + AObj.valor.toFixed(2);
            AObj.idpessoaformularioformapagamento = form.idpessoaformularioformapagamento;
            AObj.idpessoaformularioformapagamentodescricao = form.idpessoaformularioformapagamentodescricao;
            AArray.push(AObj);
            AVencimento = Helpers.addDays(AVencimento, 30).toISOString().split("T")[0];
        }

        for (let x = 0; x < form.parcela; x++) {
            let AObj = Object.assign({}, ModeloParcela);
            AObj.idtemporario += (x + 1);
            AObj.vencimento = AVencimento;
            AObj.vencimentodescricao = Helpers.StringDateUSToBR(AVencimento);
            AObj.idpessoaformularioformapagamento = form.idpessoaformularioformapagamento;
            AObj.idpessoaformularioformapagamentodescricao = form.idpessoaformularioformapagamentodescricao;
            if (x === 1) {
                AObj.valor = AValorPrimeiraParcela;
            }
            else {
                AObj.valor = AValorParcela;
            }
            AObj.valordescricao = "R$ " + AObj.valor.toFixed(2);
            AArray.push(AObj);
            AVencimento = Helpers.addDays(AVencimento, 30).toISOString().split("T")[0];
        }
        setItens(AArray);
    };

    render() {
        const { classes, className, aprazo = false, xappRouteParams } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                {aprazo &&
                    <div className={clsx(className)}>
                        <div className="flex flex-wrap lg:flex-no-wrap mt-8">
                            <TextField
                                className="mx-4 mb-12"
                                label="Primeiro vencimento"
                                id="primeirovencimento"
                                name="primeirovencimento"
                                required
                                variant="outlined"
                                fullWidth
                                value={this.state.primeirovencimento}
                                onChange={this.handleChange}
                                type="date"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <EmpresaFormaPagamentoApp
                                className="mx-4 mb-12"
                                xappRouteParams={xappRouteParams}
                                required={true}
                                isLookup={true}
                                multiSelect={false}
                                onChange={this.handleChangeFormaPagamento}
                                id="NovoFormaPagamento"
                                key="NovoFormaPagamento"
                                label="Forma de pagamento"
                                selected={!_.isNull(form.idpessoaformularioformapagamento) ? [{ idpessoaformulario: form.idpessoaformularioformapagamento, nome: form.idpessoaformularioformapagamentodescricao }] : []}
                                target="spvwempresaformapagamentolookup"
                                autoSearch={true}
                                selectFirstAuto={true}
                            />
                        </div>
                        <div className="flex flex-wrap lg:flex-no-wrap">
                            <TextField
                                className="mx-4 mb-12"
                                label="Entrada"
                                id="entrada"
                                name="entrada"
                                variant="outlined"
                                fullWidth
                                type="Number"
                                value={form.entrada}
                                onChange={this.handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                    startAdornment: <InputAdornment position="start">R$</InputAdornment>
                                }}

                            />
                            <TextField
                                className="mx-4 mb-12"
                                label="Parcelas"
                                id="parcela"
                                name="parcela"
                                variant="outlined"
                                fullWidth
                                type="Number"
                                value={form.parcela}
                                onChange={this.handleChange}
                                required
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                        <div className="flex flex-wrap lg:flex-no-wrap">
                            <Paper className={clsx(classes.paper, "flex w-full flex-row justify-end items-center mx-4")} elevation={0} rounded={true}>
                                < XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mx-4"
                                    variant="contained"
                                    color="primary"
                                    disabled={!this.canBeSubmitted()}
                                    onClick={() => this.gerarParcelas()}
                                    label={md.mobile() === null && md.tablet() === null ? "Gerar parcelas" : "Gerar"}
                                />
                            </Paper>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}


export default withStyles(styles, { withTheme: true })(TarefaApontamentoGeradorParcela);
